<template>
  <div class="salary-container">
    <div class="header-search card-shadow">
      <el-form
          ref="form"
          inline
          :model="searchData"
          label-width="80px"
          class="search-form"
      >
        <el-form-item label="月份：">
          <el-date-picker
              size="small"
              v-model="searchData.pay_month"
              type="month"
              placeholder="选择月"
              class="custom-date-picker">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
              size="small"
              v-model="searchData.order_no"
              placeholder="请输入订单号"
              class="custom-input">
          </el-input>
        </el-form-item>
        <el-form-item label=" " class="btn-group">
          <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="getList"
              class="custom-btn"
          >搜索
          </el-button>
          <el-button
              type="info"
              size="small"
              icon="el-icon-refresh"
              @click="reset"
              class="custom-btn"
          >重置
          </el-button>
          <el-button 
              type="success" 
              size="small" 
              @click="download" 
              icon="el-icon-download"
              class="custom-btn"
          >导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-row :gutter="20" class="stat-cards">
      <el-col :span="6">
        <div class="stat-card card-shadow">
          <el-statistic title="总金额" class="custom-statistic">
            <template slot="prefix">
              <i class="el-icon-money stat-icon"></i>
            </template>
            <template slot="formatter">
              <span class="money-text">¥ {{ formatMoney(stat.total_money) }}</span>
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card card-shadow">
          <el-statistic title="对公" class="custom-statistic">
            <template slot="prefix">
              <i class="el-icon-office-building stat-icon"></i>
            </template>
            <template slot="formatter">
              <span class="money-text">¥ {{ formatMoney(stat.total_money_with_company) }}</span>
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card card-shadow">
          <el-statistic title="微信" class="custom-statistic">
            <template slot="prefix">
              <i class="el-icon-chat-dot-round stat-icon"></i>
            </template>
            <template slot="formatter">
              <span class="money-text">¥ {{ formatMoney(stat.total_money_with_wechat) }}</span>
            </template>
          </el-statistic>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card card-shadow">
          <el-statistic title="支付宝" class="custom-statistic">
            <template slot="prefix">
              <i class="el-icon-wallet stat-icon"></i>
            </template>
            <template slot="formatter">
              <span class="money-text">¥ {{ formatMoney(stat.total_money_with_alipay) }}</span>
            </template>
          </el-statistic>
        </div>
      </el-col>
    </el-row>

    <div class="table-container card-shadow">
      <el-table 
          :data="list"
          stripe
          border
          class="custom-table"
          v-loading="loading"
      >
        <el-table-column prop="pay_date" label="支付时间" width="180"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" width="130"></el-table-column>
        <el-table-column prop="order_no" label="商户订单编号" width="180"></el-table-column>
        <el-table-column prop="pay_status" label="付款状态">
          <template slot-scope="{row}">
            <el-tag :type="row.pay_status === '已支付' ? 'success' : 'info'">
              {{ row.pay_status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type_dsc" label="交易账户"></el-table-column>
        <el-table-column prop="pay_price" label="收入金额" align="right">
          <template slot-scope="{row}">
            <span class="money-text">¥ {{ formatMoney(row.pay_price) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="company_name" label="开票单位信息" show-overflow-tooltip></el-table-column>
        <el-table-column
            label="操作"
            width="100"
            fixed="right"
            align="center"
        >
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="small"
                @click="handleDetail(row)"
                class="detail-btn"
            >详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer
        size="45%"
        :visible.sync="show_detail"
        direction="rtl"
        :destroy-on-close="true"
        custom-class="custom-drawer"
    >
      <Detail :detail="detail"></Detail>
    </el-drawer>
  </div>
</template>
<script>
import {getListAPI} from './api'
import {getDetailAPI} from "@/views/orderManage/order/api";
import Detail from "@/views/orderManage/order/detail.vue";
import dayjs from "dayjs";

export default {
  name: 'salary',
  components: {Detail},
  data() {
    return {
      list: [],
      show_detail: false,
      detail: {},
      searchData: {
        order_no: '',
        pay_month: dayjs().format("YYYY-MM"),
      },
      stat: {
        total_money: 0,
        total_money_with_wechat: 0,
        total_money_with_alipay: 0,
        total_money_with_company: 0,
      }
    }
  },
  mounted() {
    this.getList()
  },


  methods: {
    reset() {

    },
    download() {
      console.log(this.searchData)
      this.$fn.downloadHandle(this.searchData, '/api/api/manage/finance/order/download', '订单统计报表', 'get')
    },
    async handleDetail({id}) {
      this.detail = await getDetailAPI(id)
      this.show_detail = true
    },
    
    // 格式化金额
    formatMoney(value) {
      return Number(value || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    
    async getList() {
      this.loading = true;
      try {
        const res = await getListAPI(this.searchData)
        this.list = res.data || []

        if (this.list) {
          this.stat = {
            total_money: this.getTotalMoney(),
            total_money_with_wechat: this.getMoneyByType('微信'),
            total_money_with_alipay: this.getMoneyByType('支付宝'),
            total_money_with_company: this.getMoneyByType('对公'),
          }
        }
      } catch (error) {
        console.error('获取列表失败：', error);
      } finally {
        this.loading = false;
      }
    },
    
    reset() {
      this.searchData = {
        order_no: '',
        pay_month: dayjs().format("YYYY-MM"),
      };
      this.getList();
    },
    getTotalMoney() {
      console.log(1111)
      // 累加
      return this.list.reduce((total, item) => {
        return total + Number(item.pay_price || 0);
      }, 0);
    },
    getMoneyByType(pay_type) {
      return this.list.reduce((total, item) => {
        // 包含 支付这两个字
        if (item.pay_type_dsc.includes(pay_type)) {
          return total + Number(item.pay_price || 0);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style lang="scss" scoped>
.salary-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .card-shadow {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
    }
  }

  .header-search {
    padding: 24px;
    margin-bottom: 20px;

    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }

    .custom-input {
      width: 220px;
    }

    .custom-date-picker {
      width: 220px;
    }

    .btn-group {
      margin-left: auto;
    }

    .custom-btn {
      margin-left: 8px;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-1px);
      }
    }
  }

  .stat-cards {
    margin-bottom: 20px;

    .stat-card {
      padding: 20px;
      height: 100%;

      .custom-statistic {
        position: relative;
        padding-left: 40px;

        .stat-icon {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 28px;
          color: #409EFF;
          opacity: 0.8;
        }

        .el-statistic__title {
          font-size: 16px;
          color: #606266;
          margin-bottom: 10px;
        }

        .money-text {
          font-size: 24px;
          font-weight: bold;
          color: #409EFF;
        }
      }
    }
  }

  .table-container {
    padding: 20px;

    .custom-table {
      margin-top: 10px;

      .money-text {
        color: #67C23A;
        font-weight: 500;
      }

      .detail-btn {
        color: #409EFF;
        padding: 4px 8px;
        
        &:hover {
          color: #66b1ff;
        }
      }
    }
  }
}

.custom-drawer {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
  }

  .el-drawer__body {
    padding: 20px;
  }
}
</style>
